"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regeneratorRuntime = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _createSuper = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var _inherits = require("/codebuild/output/src32004911/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var BaseTask_1 = require("./BaseTask");
/**
 * [[ReceiveAudioInputTask]] acquires an audio input.
 */


var ReceiveAudioInputTask = /*#__PURE__*/function (_BaseTask_1$default) {
  _inherits(ReceiveAudioInputTask, _BaseTask_1$default);

  var _super = _createSuper(ReceiveAudioInputTask);

  function ReceiveAudioInputTask(context) {
    var _this;

    _classCallCheck(this, ReceiveAudioInputTask);

    _this = _super.call(this, context.logger);
    _this.context = context;
    _this.taskName = 'ReceiveAudioInputTask';
    return _this;
  }

  _createClass(ReceiveAudioInputTask, [{
    key: "run",
    value: function run() {
      var _a, _b;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var audioInput;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if ((_b = (_a = this.context.meetingSessionConfiguration) === null || _a === void 0 ? void 0 : _a.urls) === null || _b === void 0 ? void 0 : _b.audioHostURL) {
                  _context.next = 3;
                  break;
                }

                this.context.logger.info('No audio connection: not acquiring audio input');
                return _context.abrupt("return");

              case 3:
                if (!this.context.activeAudioInput) {
                  _context.next = 6;
                  break;
                }

                this.context.logger.info('an active audio input exists');
                return _context.abrupt("return");

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return this.context.mediaStreamBroker.acquireAudioInputStream();

              case 9:
                audioInput = _context.sent;
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](6);
                this.context.logger.warn('could not acquire audio input from current device');

              case 15:
                if (audioInput) {
                  this.context.activeAudioInput = audioInput;
                  this.context.realtimeController.realtimeSetLocalAudioInput(audioInput);
                } else {
                  this.context.logger.warn('an audio input is not available');
                }

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));
    }
  }]);

  return ReceiveAudioInputTask;
}(BaseTask_1.default);

exports.default = ReceiveAudioInputTask;